import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: ProviderUpdateInput!
  ) {
    updateOneProvider(
      where: {
        id: $id
      }
      data: $data
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Fornecedor actualizado`, mutationTypes.UPDATE)
)

